import { Div, Image, Link, Span } from "@tblabs/truffle";
import { BasketItem } from "../../../Models/Basket/BasketItem";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { RentBasketItem } from "../../../Models/Basket/RentBasketItem";
import { SaleBasketItem } from "../../../Models/Basket/SaleBasketItem";


export class CartItemBox extends Div
{
    constructor(cartItem: BasketItem)
    {
        super("basket-cart-item");

        this.Append(
            new Image(cartItem.ProductInfo.Picture, cartItem.ProductInfo.Name).Class("basket-cart-item-image"),
            new Div("basket-cart-item-details").Append(
                new Link(cartItem.ProductInfo.Name, cartItem.ProductInfo.Link),
                new Span(`×${cartItem.Quantity.value}`).MarginLeft(8),
                new Div("basket-cart-item-dates").Text(`${cartItem.Option.Name || ""}`),
                (cartItem instanceof RentBasketItem) && new Div("basket-cart-item-dates").Text(`📆 Wynajem ${TimeUtils.FormattedRange(cartItem.From, cartItem.To)}`),
                (cartItem instanceof SaleBasketItem) && new Div("basket-cart-item-dates").Text(`🛒 Zakup`),
            )
        )
    }
}
